"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M4 15V20H20V15", stroke: "currentColor", strokeWidth: "1.5", strokeLinejoin: "round" }),
    react_1.default.createElement("path", { d: "M12 3V14.3036M6 10L12 15L18 10", stroke: "currentColor", strokeWidth: "1.5", strokeLinejoin: "round" })));
